export enum NotificationNewComunication {
    NO_COMUNICATION = '0',
    COMUNICATION = '1',
}